export default __webpack_public_path__ + "static/media/wheel_2.dcd34fea.svg";